import { PeriodSegment } from '../../models/timeline-calendar.types';

interface TimelinePeriodHeaderProps {
  periodSegments: PeriodSegment[];
  stickyTopOffset?: number;
  sticky?: boolean;
}

export const TimelinePeriodHeader = ({
  periodSegments,
  stickyTopOffset = 0,
  sticky = true,
}: TimelinePeriodHeaderProps) => {
  const labelSegments = periodSegments
    .map((segment, index) => ({ segment, index }))
    .filter(({ segment }) => segment.showLabel);

  return (
    <div
      className={sticky ? 'sticky' : ''}
      data-testid="timeline-period-header"
      style={{
        top: sticky ? `${stickyTopOffset}px` : undefined,
        backgroundColor: 'var(--color-bg-app)',
        zIndex: 20,
      }}
    >
      <div
        className="relative h-8"
        style={{ borderBottom: '1px solid var(--color-border)' }}
      >
        <div className="flex">
          {periodSegments.map((segment, index) => {
            return (
              <div
                key={`${segment.start.toISOString()}-${segment.endExclusive.toISOString()}`}
                className="h-8"
                style={{
                  width: `${segment.widthPct}%`,
                  borderRight: index < periodSegments.length - 1
                    ? '1px solid var(--color-border)'
                    : 'none',
                }}
              />
            );
          })}
        </div>
        <div className="pointer-events-none absolute inset-0">
          {labelSegments.map(({ segment }, labelIndex) => {
            const nextLabelSegment = labelSegments[labelIndex + 1]?.segment;
            const nextLeftPct = nextLabelSegment ? nextLabelSegment.leftPct : 100;
            const dynamicWidthPct = Math.max(segment.widthPct, nextLeftPct - segment.leftPct);

            return (
              <div
                key={`period-label-${segment.start.toISOString()}-${segment.leftPct}`}
                data-testid={`timeline-period-label-${labelIndex}`}
                className="absolute flex h-8 items-center whitespace-nowrap px-2 text-left text-[10px] font-medium"
                style={{
                  left: `${segment.leftPct}%`,
                  width: `${dynamicWidthPct}%`,
                  color: 'var(--color-text-tertiary)',
                  letterSpacing: '0.03em',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {segment.label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
